// import external modules
import React, { Component } from "react";
import { connect } from "react-redux";
import { Input, FormGroup, Label } from "reactstrap";
import CustomDropdown from "../../../../components/customDropdown";
import QuickActions from "../../../../components/quickActions";
import Title from "../../../../components/title";
export const exportDropdownListitems = [
  {
    innertitle: "Excel",
    svg: require("../../../../assets/images/excel.svg"),
  },
  //Note: Hide export all, since currently we don't support export all directly. we support export all by batches, by "Export" button. max 30 records each time.
  // {
  //   innertitle: "Excel (All)",
  //   svg: require("../../../../assets/images/excel.svg"),
  // },
  {
    svg: require("../../../../assets/images/pdf.svg"),
    innertitle: "Pdf",
  },
  // {
  //   svg: require("../../../../assets/images/pdf.svg"),
  //   innertitle: "Pdf (All)",
  // },
];
export const importDropdownListItems = [
  {
    innertitle: "Download Template",
    // svg: require("../../../../assets/images/download.svg"),
  },
  {
    innertitle: "Upload Members",
    // svg: require("../../../../assets/images/upload-sm.svg"),
    svg: require("../../../../assets/images/excel.svg"),
  },
];
const quickActionsList = [
  // {
  //   innertitle: "Freeze All",
  //   // svg:
  // },
  {
    innertitle: "Push Notification",
  },
];
const capsualList = [
  {
    id: "1",
    title: "Bookings",
  },
  {
    id: "2",
    title: "Numbers of offers sold",
  },
  {
    id: "3",
    title: "Sales",
  },
  {
    id: "4 ",
    title: "New Clients",
  },
];

class MemberFilter extends Component {
  state = {
    isOpenfilter: false,
    search: "",
    filter: "",
    sort: "",
    gender: "",
  };

  togglefilter = () => {
    //console.log('red work');
    this.setState({
      isOpenfilter: !this.state.isOpenfilter,
    });
  };

  handleFilter = (search, filter, sort, gender) => {
    console.log({ gender }, "geeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
    //console.log(search, filter, sort);
    this.props.search(search, filter, sort, gender);
  };

  get quickActionsListEnabled () {
    return (this.props.gymConfig?.sendCustomPushNotifications?.enabled || (this.props.gymConfig?.manageMemberships?.enabled && this.props.gymConfig?.manageMemberships?.freezeAllOrSelection));
  }
  render() {
    return (
      <div className="card-panel">
        <div className="table-filter-header">
          <div className="filters">
            <div className="filters-main-wrapper">
              <ul className="filter-list-wraper">
                <li className="search-block filter-list-element flex-fill">
                  <FormGroup className="mb-md-0 mb-sm-0  search-input-filter w-100">
                    <Label
                      for="firstname"
                      className={this.state.isOpenfilter ? "f-700" : " "}
                    >
                      {this.props.searchLabel}
                    </Label>
                    <div className="search-input position-relative">
                      <Input
                        type="text"
                        name="First Name"
                        id=""
                        placeholder={this.props.searchPlaceholder}
                        onChange={(e) => {
                          this.setState({ search: e.target.value });
                          this.handleFilter(
                            e.target.value,
                            this.state.filter,
                            this.state.sort,
                            this.state.gender
                          );
                        }}
                      />
                      <div className="search-icon">
                        <svg
                          width="24px"
                          height="24px"
                          viewBox="0 0 24 24"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="Admin-account"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                            opacity="0.5"
                          >
                            <g
                              id="Gym"
                              transform="translate(-360.000000, -148.000000)"
                            >
                              <g
                                id="Group-14"
                                transform="translate(324.000000, 102.000000)"
                              >
                                <g
                                  id="search-24px-(1)"
                                  transform="translate(36.000000, 46.000000)"
                                >
                                  <polygon
                                    id="Path"
                                    points="0 0 24 0 24 24 0 24"
                                  ></polygon>
                                  <path
                                    d="M15.5,14 L14.71,14 L14.43,13.73 C15.63,12.33 16.25,10.42 15.91,8.39 C15.44,5.61 13.12,3.39 10.32,3.05 C6.09,2.53 2.53,6.09 3.05,10.32 C3.39,13.12 5.61,15.44 8.39,15.91 C10.42,16.25 12.33,15.63 13.73,14.43 L14,14.71 L14,15.5 L18.25,19.75 C18.66,20.16 19.33,20.16 19.74,19.75 C20.15,19.34 20.15,18.67 19.74,18.26 L15.5,14 Z M9.5,14 C7.01,14 5,11.99 5,9.5 C5,7.01 7.01,5 9.5,5 C11.99,5 14,7.01 14,9.5 C14,11.99 11.99,14 9.5,14 Z"
                                    id="Shape"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                  ></path>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </FormGroup>
                </li>

                <li className="select-filter-block filter-list-element flex-fill">
                  <FormGroup className="select-filter mb-md-0 mb-sm-0 w-100">
                    <Label className={this.state.isOpenfilter ? "f-700" : " "}>
                      {"Add filter to search"}
                    </Label>
                    <div className="select-filter-wrapper">
                      <Input
                        type="select"
                        name="select"
                        id="exampleSelect"
                        onChange={(e) => {
                          this.setState({ filter: e.target.value });
                          this.handleFilter(
                            this.state.search,
                            e.target.value,
                            this.state.sort,
                            this.state.gender
                          );
                        }}
                      >
                        <option value="">Select Filters</option>
                        <option value="Y">Status Active</option>
                        <option value="N">Status Non-Active</option>
                        <option value="F">Status Freeze</option>
                        <option value="EXM">Expiring This Month</option>
                      </Input>
                      <div className="search-filter-img">
                        <svg
                          width="24px"
                          height="26px"
                          viewBox="0 0 24 26"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="Admin-account"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                            opacity="0.5"
                          >
                            <g
                              id="Admins-List"
                              transform="translate(-780.000000, -147.000000)"
                            >
                              <g
                                id="Group-14"
                                transform="translate(324.000000, 102.000000)"
                              >
                                <g
                                  id="filter_alt-24px"
                                  transform="translate(456.000000, 45.000000)"
                                >
                                  <path
                                    d="M0,1 L24,1 M24,25 L0,25"
                                    id="Shape"
                                  ></path>
                                  <path
                                    d="M4.25,6.61 C6.57,9.59 10,14 10,14 L10,19 C10,20.1 10.9,21 12,21 L12,21 C13.1,21 14,20.1 14,19 L14,14 C14,14 17.43,9.59 19.75,6.61 C20.26,5.95 19.79,5 18.95,5 L5.04,5 C4.21,5 3.74,5.95 4.25,6.61 Z"
                                    id="Path"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                  ></path>
                                  <polygon
                                    id="Path"
                                    points="0 1 24 1 24 25 0 25"
                                  ></polygon>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </FormGroup>
                </li>
                <li className="select-filter-block filter-list-element flex-fill">
                  <FormGroup className="select-filter mb-md-0 mb-sm-0 w-100">
                    <Label className={this.state.isOpenfilter ? "f-700" : " "}>
                      {"Filter by Gender"}
                    </Label>
                    <div className="select-filter-wrapper">
                      <Input
                        type="select"
                        name="select"
                        id="exampleSelect"
                        onChange={(e) => {
                          console.log(
                            e.target.value,
                            "eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee"
                          );
                          this.setState({ gender: e.target.value });
                          this.handleFilter(
                            this.state.search,
                            this.state.filter,
                            this.state.sort,
                            e.target.value
                          );
                        }}
                      >
                        <option value="">Select Gender</option>
                        <option value="F">Female</option>
                        <option value="M">Male</option>
                      </Input>
                      <div className="search-filter-img">
                        <svg
                          width="24px"
                          height="26px"
                          viewBox="0 0 24 26"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="Admin-account"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                            opacity="0.5"
                          >
                            <g
                              id="Admins-List"
                              transform="translate(-780.000000, -147.000000)"
                            >
                              <g
                                id="Group-14"
                                transform="translate(324.000000, 102.000000)"
                              >
                                <g
                                  id="filter_alt-24px"
                                  transform="translate(456.000000, 45.000000)"
                                >
                                  <path
                                    d="M0,1 L24,1 M24,25 L0,25"
                                    id="Shape"
                                  ></path>
                                  <path
                                    d="M4.25,6.61 C6.57,9.59 10,14 10,14 L10,19 C10,20.1 10.9,21 12,21 L12,21 C13.1,21 14,20.1 14,19 L14,14 C14,14 17.43,9.59 19.75,6.61 C20.26,5.95 19.79,5 18.95,5 L5.04,5 C4.21,5 3.74,5.95 4.25,6.61 Z"
                                    id="Path"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                  ></path>
                                  <polygon
                                    id="Path"
                                    points="0 1 24 1 24 25 0 25"
                                  ></polygon>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </FormGroup>
                </li>
                <li className="select-filter-block filter-list-element flex-fill">
                  <FormGroup className="select-filter mb-md-0 mb-sm-0 w-100">
                    <Label className={this.state.isOpenfilter ? "f-700" : " "}>
                      {"Add sorting to search"}
                    </Label>
                    <div className="select-filter-wrapper">
                      <Input
                        type="select"
                        name="select"
                        id="exampleSelect"
                        onChange={(e) => {
                          this.setState({ sort: e.target.value });
                          this.handleFilter(
                            this.state.search,
                            this.state.filter,
                            e.target.value,
                            this.state.gender
                          );
                        }}
                      >
                        <option value="">Select Field To Sort</option>
                        <option value="createdAt asc">Created Date ASC</option>
                        <option value="createdAt desc">
                          Created Date DESC
                        </option>
                        <option value="updatedAt asc">Updated Date ASC</option>
                        <option value="updatedAt desc">
                          Updated Date DESC
                        </option>
                      </Input>
                      <div className="search-filter-img">
                        <svg
                          width="24px"
                          height="26px"
                          viewBox="0 0 24 26"
                          version="1.1"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g
                            id="Admin-account"
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                            opacity="0.5"
                          >
                            <g
                              id="Admins-List"
                              transform="translate(-780.000000, -147.000000)"
                            >
                              <g
                                id="Group-14"
                                transform="translate(324.000000, 102.000000)"
                              >
                                <g
                                  id="filter_alt-24px"
                                  transform="translate(456.000000, 45.000000)"
                                >
                                  <path
                                    d="M0,1 L24,1 M24,25 L0,25"
                                    id="Shape"
                                  ></path>
                                  <path
                                    d="M4.25,6.61 C6.57,9.59 10,14 10,14 L10,19 C10,20.1 10.9,21 12,21 L12,21 C13.1,21 14,20.1 14,19 L14,14 C14,14 17.43,9.59 19.75,6.61 C20.26,5.95 19.79,5 18.95,5 L5.04,5 C4.21,5 3.74,5.95 4.25,6.61 Z"
                                    id="Path"
                                    fill="#000000"
                                    fill-rule="nonzero"
                                  ></path>
                                  <polygon
                                    id="Path"
                                    points="0 1 24 1 24 25 0 25"
                                  ></polygon>
                                </g>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </FormGroup>
                </li>
                {this.quickActionsListEnabled && ((this.props.loginUser.role === "STAFF" &&
                  !this.props.permissions["S-EXP"]) ||
                (this.props.subAdminType === "SUB_ADMIN" &&
                  !this.props.subAdminPermissions["S-EXP"]) ? null : (
                  <li className="dropdown filter-list-element">
                    <QuickActions
                      dropdownitems={quickActionsList}
                      maintitle="Quick Actions"
                      subTitle="Quick Actions"
                      data={this.props.data}
                      selection={this.props.selection}
                    />
                    {
                      this.props.gymConfig?.exportData?.enabled &&
                      <CustomDropdown
                        dropdownitems={exportDropdownListitems}
                        maintitle="Export data"
                        type={this.props.type}
                        handleExcel={this.props.handleExcel}
                        handlepdf={this.props.handlepdf}
                        handleExcelAll={this.props.handleExcelAll}
                        handlepdfAll={this.props.handlepdfAll}
                      />
                    }
                  </li>
                ))}
                {this.props.gymConfig?.importData?.enabled &&
                  (this.props.loginUser.role === "STAFF"
                    ? this.props.permissions["S-IMP"]
                    : true) &&
                  this.props.gym?.subscriptionPlan?.id != 1 && (
                    <li className="dropdown filter-list-element">
                      <CustomDropdown
                        dropdownitems={importDropdownListItems}
                        maintitle="Import data"
                        subtitle=" "
                        type={this.props.type}
                        handleImportMembers={this.props.handleImportMembers}
                        handleDownloadTemplate={
                          this.props.handleDownloadTemplate
                        }
                      />
                    </li>
                  )}
              </ul>
            </div>
          </div>
          <div
            className={
              this.state.isOpenfilter ? "other-filter active" : "other-filter"
            }
          >
            <div className="border-bottom-1 blk-padding-y pb-0"></div>
            <div className="info-title blk-padding-y">
              <Title title="Other Filter" />
            </div>
            <div className="selction-box">
              <ul className="other-filter-list">
                {capsualList.map((value, index) => {
                  return (
                    <li className="other-filter-list-element">
                      <FormGroup className="checkboxes-list" check>
                        <Label check className="container-blk">
                          <Input type="checkbox" id={value.id} /> {value.title}
                          <span className="checkmark"></span>
                        </Label>
                      </FormGroup>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { loginUser } = state.login;
  const { permissions, subAdminType, subAdminPermissions } = state.permissions;
  const { gym, gymConfig } = state.gym;
  return { loginUser, permissions, subAdminType, subAdminPermissions, gym, gymConfig };
};
export default connect(mapStateToProps, {})(MemberFilter);
